import { render, staticRenderFns } from "./interactionDetailDialog.vue?vue&type=template&id=ef064dce&scoped=true"
import script from "./interactionDetailDialog.vue?vue&type=script&lang=js"
export * from "./interactionDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./interactionDetailDialog.vue?vue&type=style&index=0&id=ef064dce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef064dce",
  null
  
)

export default component.exports